// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'staging',
  apiServer: "https://m5nius1kad.execute-api.eu-west-2.amazonaws.com/1",
  clientToken: "00077fb207563531744240dh0926j56fnxbpumcl4ffkfaler12bburvuj0b60lf",
  observeVehicleQuestionId: 649,
  jrniApi: "kent-staging.council.bookingbug.com",
  jrniCompanyId: 37023,
  externalConfigDomain: "https://d3d3ncwi2swiss.cloudfront.net",
  test: true
};

/*
 * HERE 
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
